import "core-js/modules/es6.regexp.replace";
import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import router from "../router";
import i18n from "../resources/index";
var service = axios.create({// process.env.NODE_ENV === 'development' 来判断是否开发环境
});
service.interceptors.request.use(function (config) {
  // 判断本地的cookie中是否有token
  if (localStorage.getItem('token') != null) {
    config.headers['Authorization'] = 'BasicAuth ' + localStorage.getItem('token');
  }

  return config;
}, function (error) {
  console.log(error);
  return Promise.reject();
});
service.interceptors.response.use(function (response) {
  if (response.status === 200) {
    return response.data;
  } else {
    Promise.reject();
  }
}, function (error) {
  console.log(error); // 过期跳转登录页

  if (error.response.status === 403) {
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token');
      router.replace({
        path: '/login'
      });
      MessageBox.alert(i18n.t('Message.loginAgain'), i18n.t('Message.tip'), {
        confirmButtonText: i18n.t('Button.confirm'),
        type: 'warning',
        showClose: false
      }).then(function () {});
    }

    setTimeout(function () {
      //关闭所有message实例
      Message.closeAll();
    }, 500);
  }

  return Promise.reject();
});
export default service;